import {Component, OnInit} from '@angular/core';
import { Role} from '@app/modules/shared/data/constants';
import {VcrEntity} from '@app/models/vcr-entity/entity';
import {Store} from '@ngxs/store';
import {ActivatedRoute, Router} from '@angular/router';
import {interval, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {LocalUser, LocalUserAction, LocalUserState} from '@app/state/local-user.state';
import {AppBaseInfo} from '@app/models/vcr-entity/app-base-info';
import {User} from '@app/models/vcr-entity/user';
import {LoginService} from '@app/modules/auth/services/login.service';
import {ClassroomAction, ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {CookieService} from '@app/modules/shared/services/cookie.service';
import {DiagnosticsService} from '@app/modules/diagnostics/services/diagnostics.service';
import {ClassroomInitService} from '@app/modules/shared/services/classroom-init.service';
import {CoreService} from '@app/services/core.service';

@Component({
  selector: 'app-guest',
  templateUrl: './guest.component.html',
  styleUrls: ['./guest.component.css']
})
export class GuestComponent implements OnInit {
  public loginData = {name: ''};
  public errorMessage: string;
  public smartsuppUsername: string;
  private localUser: LocalUser;
  private classroom: ClassroomStateModel;

  constructor(
    private coreService: CoreService,
    private loginService: LoginService,
    private cookieService: CookieService,
    private diagnosticsService: DiagnosticsService,
    private classroomInitService: ClassroomInitService,
    private store: Store,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    this.listenStoreChanges();

    this.activatedRoute.queryParams.subscribe(params => {
      const name = params.name;
      if (name) {
        this.loginData.name = name;
        this.login();
      }
    });

    const pauseInterval: Subject<void> = new Subject();
    interval(500).pipe(takeUntil(pauseInterval)).subscribe(() => {
      const visitorId: string = this.cookieService.get('ssupp.vid');
      if (visitorId) {
        this.smartsuppUsername = 'Guest-' + visitorId;
        pauseInterval.next();
      }
    });
  }

  private listenStoreChanges() {
    this.store.select(LocalUserState).subscribe((localUser: LocalUser) => {
      this.localUser = localUser;
    });
    this.store.select(ClassroomState).subscribe((room: ClassroomStateModel) => {
      this.classroom = room;
    });
  }

  public login(event?: any) {
    event?.preventDefault();
    if (this.classroom.isDnDEnabled && !this.localUser.isCurrentClassParticipant) {
      this.router.navigateByUrl(`/${this.classroom.roomNum}/classroomClosed?classId=${this.classroom.currentClass.groupId}`).then();
    }
    this.loginService.guestLogin(this.loginData).subscribe((result) => {
      const appBaseInfo: AppBaseInfo = VcrEntity.createEntity(AppBaseInfo, result.data);
      appBaseInfo.sessionUser = VcrEntity.createEntity(User, appBaseInfo.sessionUser);
      this.store.dispatch(new LocalUserAction.SetLocalUser(new LocalUser(appBaseInfo.sessionUser)));
      this.store.dispatch(new ClassroomAction.ToggleDnDMode(appBaseInfo.isInDNDMode));
      this.coreService.setCurrentClass(appBaseInfo.currentClass);

      if (appBaseInfo.sessionUser.role !== Role.STUDENT) {
        if (appBaseInfo.isClassClosed) {
          this.router.navigateByUrl(`/${this.classroom.roomNum}/loginDetails`).then();
        } else {
          this.classroomInitService.navigateToHome();
        }

      } else {
        if (appBaseInfo.isClassClosed) {
          this.router.navigateByUrl(`/${this.classroom.roomNum}/classroomClosed`).then();
        } else if (this.classroom.isDnDEnabled && this.cookieService.get('diagnostics-passed')) {
          this.router.navigateByUrl(`/${this.classroom.roomNum}/classroomClosed?classId=${this.classroom.currentClass.groupId}`).then();
        } else {
          this.classroomInitService.navigateToHome();
        }
      }
    }, error => {
      if (error.message) {
        this.errorMessage = 'Your class has not started yet. Please try again later.';
      } else {
        this.errorMessage = 'Unknown error';
      }
    });
  }
}
